/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createAcsch } from '../../factoriesAny.js';
export var acschDependencies = {
  BigNumberDependencies,
  typedDependencies,
  createAcsch
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesAcsch.generated.js
// module id = 1302
// module chunks = 2